export default "__VITE_ASSET__fas145YM__"